function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M319.922,238.281c15.519-.13,27.175,1.485,41.016,2.735l17.578-.782c0.31,3.914,3.5,16.483,0,19.141-18.291,8.09-38.555-6.876-57.032-3.906-14.77,2.374-19.613,8.082-28.906,14.843H291.8q-0.392-.78-0.781-1.562c4.038-13.433,4.177-22.671,16.406-27.734Zm135.156,0c27.594,1.412,50.189,1.511,50.781,30.86l-0.781.39C493.6,262.786,491.565,258,474.219,255.078c-18.194-3.063-41.64,13.022-56.641,4.688-0.146-6.964.362-14.3,2.344-19.532C429.458,241.218,448.392,241.049,455.078,238.281Z"
});

var SvgOmEyebrowshapeSVector = function SvgOmEyebrowshapeSVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "om_eyebrowshape_s_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOmEyebrowshapeSVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/om_eyebrowshape_s_vector.8afcc9da.svg";
export { ForwardRef as ReactComponent };